import React from 'react';
import '../css/App.css';

export default function ThankYou() {
  return (
    <div className="content" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '30px 40px',
        borderRadius: '8px',
        maxWidth: '600px'
      }}>
        <p style={{
          fontSize: '1.5rem',
          marginBottom: '20px',
          color: 'white'
        }}>thank you all for coming! <br />see you soon 🫰</p>
        
        <div style={{
          margin: '30px 0',
          padding: '20px',
          borderTop: '1px solid rgba(255, 255, 255, 0.3)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
          textAlign: 'left'
        }}>
          <p style={{
            fontSize: '1.1rem',
            marginBottom: '15px',
            color: 'white'
          }}>Hey friends - thank you for joining us for Blink last weekend.</p>
          
          <p style={{
            fontSize: '1rem',
            marginBottom: '15px',
            color: 'white',
            lineHeight: '1.5'
          }}>The mud has finally settled, and we entered the week with overwhelming joy. Thanks for making the night so special. Especially for braving the unexpectedly heavy rain and dancing with us until the early hours of the morning.</p>
          
          <p style={{
            fontSize: '1rem',
            marginBottom: '15px',
            color: 'white',
            lineHeight: '1.5'
          }}>Unfortunately, we had to find out that one of the speakers didn't handle the rain so well and is now broken. Without this incident, we would've come out with a small loss. Now we're facing the possibility of a heavier loss (&gt;3000 DKK to be transparent).</p>
          
          <p style={{
            fontSize: '1rem',
            marginBottom: '15px',
            color: 'white',
            lineHeight: '1.5'
          }}>It (really) sucks that this thank you message is also about money, overshadowing the many beautiful moments we shared on the dancefloor. But, we need to sort this situation out, so that it also remains sustainable for us to keep throwing the parties in the same spirit.</p>
          
          <p style={{
            fontSize: '1rem',
            marginBottom: '15px',
            color: 'white',
            lineHeight: '1.5'
          }}>So, if you had a great time with us and have the sweet, sweet thought that more Blinks should happen in the future, we'd be incredibly grateful for any donation, no matter how small, to help us cover these extra costs.</p>
          
          <p style={{
            fontSize: '1.1rem',
            marginBottom: '15px',
            color: '#add8e6',
            fontWeight: 'bold'
          }}>MP Box: 5749MA</p>
          
          <p style={{
            fontSize: '1.1rem',
            color: 'white',
            marginTop: '20px'
          }}>Take care everyone ❤</p>
        </div>
        
        <p style={{
          fontSize: '1rem',
          marginTop: '30px',
          color: 'white'
        }}>for lost and found please reach out to: <br /><a href="tel:+4581913588" style={{ color: '#add8e6' }}>+45 81 91 35 88</a></p>
        
        <p style={{
          fontSize: '1rem',
          marginTop: '15px',
          color: 'white'
        }}>for future updates join our telegram chat: <br /> <a href="https://t.me/+u0xX2SUgaQwxOWY0" style={{ color: '#add8e6' }} target="_blank" rel="noopener noreferrer">t.me/+u0xX2SUgaQwxOWY0</a></p>
      </div>
    </div>
  );
}
